import { Control, ControlType } from './control';

export class DateControl extends Control<Date> {
  constructor(name: string, placeholder: string, type: ControlType) {
    super(name, placeholder, type);
  }
}
